import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=27a0451c&scoped=true"
import script from "./main-layout.vue?vue&type=script&lang=ts"
export * from "./main-layout.vue?vue&type=script&lang=ts"
import style0 from "./main-layout.vue?vue&type=style&index=0&id=27a0451c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0451c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a0451c')) {
      api.createRecord('27a0451c', component.options)
    } else {
      api.reload('27a0451c', component.options)
    }
    module.hot.accept("./main-layout.vue?vue&type=template&id=27a0451c&scoped=true", function () {
      api.rerender('27a0451c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/main-layout.vue"
export default component.exports